var render = function render(){
  var _vm$lawyer, _vm$lawyer2, _vm$lawyer3, _vm$lawyer4, _vm$lawyer5, _vm$lawyer6, _vm$lawyer7, _vm$lawyer8, _vm$lawyer9, _vm$lawyer0;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "lawyer-card",
    class: {
      'lawyer-card--hover': _vm.mouseOver
    },
    attrs: {
      "elevation": "0",
      "to": _vm.mouseOver == false ? _vm.lang === 'en' ? `/en/attorneys/view?code=${_vm.code}` : `/attorneys/view?code=${_vm.code}` : ''
    }
  }, [_c('div', {
    staticClass: "lawyer-contents mb-20px mb-lg-24px"
  }, [_c('div', {
    staticClass: "lawyer-content lawyer-content--view h-100"
  }, [_c('v-card', {
    attrs: {
      "tile": "",
      "color": "grey lighten-5",
      "height": "100%"
    }
  }, [_c('v-img', {
    staticClass: "mx-auto mt-auto",
    attrs: {
      "aspect-ratio": 444 / 564,
      "src": `${(_vm$lawyer = _vm.lawyer) === null || _vm$lawyer === void 0 ? void 0 : _vm$lawyer.image}`
    }
  })], 1)], 1), _vm.mouseOver ? _c('div', {
    staticClass: "lawyer-content lawyer-content--active"
  }, [_c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": _vm.$vuetify.breakpoint.lgAndUp ? 444 : '',
      "aspect-ratio": 444 / 564,
      "src": _vm.imageActive
    }
  }), _c('div', {
    staticClass: "lawyer-content--active__inner"
  }, [_c('div', {
    staticClass: "white--text"
  }, [_c('p', {
    staticClass: "txt white--text line-height-15 lawyer__detail-txt"
  }, [_vm._v(" " + _vm._s((_vm$lawyer2 = _vm.lawyer) === null || _vm$lawyer2 === void 0 ? void 0 : _vm$lawyer2.about) + " ")]), _c('div', {
    staticClass: "lawyer__info txt line-height-1 ellip white--text"
  }, [(_vm$lawyer3 = _vm.lawyer) !== null && _vm$lawyer3 !== void 0 && _vm$lawyer3.phone ? _c('div', {
    staticClass: "mb-4px mb-lg-8px"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + ((_vm$lawyer4 = _vm.lawyer) === null || _vm$lawyer4 === void 0 ? void 0 : _vm$lawyer4.phone)
    }
  }, [_vm._v(_vm._s((_vm$lawyer5 = _vm.lawyer) === null || _vm$lawyer5 === void 0 ? void 0 : _vm$lawyer5.phone))])]) : _vm._e(), (_vm$lawyer6 = _vm.lawyer) !== null && _vm$lawyer6 !== void 0 && _vm$lawyer6.email ? _c('div', [_c('a', {
    attrs: {
      "href": 'mailto:' + ((_vm$lawyer7 = _vm.lawyer) === null || _vm$lawyer7 === void 0 ? void 0 : _vm$lawyer7.email)
    }
  }, [_vm._v(_vm._s((_vm$lawyer8 = _vm.lawyer) === null || _vm$lawyer8 === void 0 ? void 0 : _vm$lawyer8.email))])]) : _vm._e()])]), _c('v-btn', {
    attrs: {
      "to": _vm.lang === 'ko' ? `/attorneys/view?code=${_vm.code}` : `/en/attorneys/view?code=${_vm.code}`,
      "small": "",
      "outlined": "",
      "color": "white",
      "width": "fit-content"
    }
  }, [_vm._v(" " + _vm._s(_vm.lang === "ko" ? "더보기" : "Read More") + " ")])], 1)], 1) : _vm._e()]), _c('div', {
    staticClass: "px-12px px-md-16px"
  }, [_c('h4', {
    staticClass: "tit tit--xs line-height-1 mb-4px mb-lg-10px"
  }, [_vm._v(" " + _vm._s((_vm$lawyer9 = _vm.lawyer) === null || _vm$lawyer9 === void 0 ? void 0 : _vm$lawyer9.name) + " ")]), _c('p', {
    staticClass: "txt txt--sm grey--text font-weight-medium line-height-1"
  }, [_vm._v(" " + _vm._s((_vm$lawyer0 = _vm.lawyer) === null || _vm$lawyer0 === void 0 ? void 0 : _vm$lawyer0.rank) + " ")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }